// this file added for individual by Bearer Web Developer
import React, { useRef } from "react";
import AvatarEditor from "./avatarEditor";
import styles from './avatarPart.module.scss';
import { Button } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import { useAppState } from "../../../../states/app-state";

const AvatarPart: React.FC = () => {

    const fileInputRef = useRef<HTMLInputElement | null>(null); // added by Bearer Web Developer
    const [preview, setPreview] = React.useState(""); // added by Bearer Web Developer
    const appState = useAppState();
    const { newCustomer } = appState;

    const handleDeleteImage = () => {
        if (newCustomer.avatar_url) {
            appState.profile.deleteProfileImage();
            newCustomer.setAvatarUrl('');
            setPreview('');
        }
    }
    return (
        <div className={styles.avatar_part}>
            <div className={styles.avatar_content}>
                <AvatarEditor fileInputRef={fileInputRef} preview={preview} setPreview={setPreview} />
            </div>
            <div className={styles.edit_and_delete}>
                <Button className={styles.edit} style={{ minWidth: "unset", padding: "4px" }}
                    onClick={(event) => {
                        event.preventDefault();
                        fileInputRef.current?.click()
                    }}
                >
                    <img src="/edit.svg" alt="" width={24} height={24} />
                </Button>
                <Button className={styles.delete} style={{ minWidth: "unset", padding: "4px" }} onClick={handleDeleteImage}>
                    <DeleteIcon color="secondary" />
                </Button>
            </div>
        </div>
    )
}
export default AvatarPart;
